import { SelectBoxInput } from '@aqarmap/aqarmap-ui';
import React, { useMemo, useState } from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Languages } from '~/constants/enums';
import { PersonalInfoItems } from '~myAccount/enums';
import { getPersonalInfo } from '~/modules/myAccount/pages/PersonalInfo/utils/getPersonalInfo';

const Question = ({
  label,
  name,
  control,
  questionText,
}: {
  label: PersonalInfoItems;
  name: string;
  control: any;
  questionText: string;
}) => {
  const [showContent, setShowContent] = useState(false);
  const { i18n } = useTranslation();
  const locale = i18n.language;
  const isEnglish = locale === Languages.ENGLISH;

  const personalInfoOptions = useMemo(() => getPersonalInfo(label), [label]);

  return (
    <Controller
      control={control}
      name={name}
      render={(field) => {
        const selectedOption = personalInfoOptions.find(
          (item) =>
            item.value ===
            (field.field.value !== '' ? field.field.value : null),
        );

        const selectedLabel = isEnglish
          ? selectedOption?.title
          : selectedOption?.title_ar;

        return (
          <div className="w-full flex flex-col gap-1.5x">
            <SelectBoxInput
              open={showContent}
              setOpen={setShowContent}
              label={{
                className: 'text-title-5 text-black',
                text: questionText,
              }}
              field={{
                value: selectedLabel,
                onChange: field.field.onChange,
                onBlur: field.field.onBlur,
              }}
              dropDownProps={{
                menuClassName: '[&>div]:!rounded-t-none',
              }}
            >
              <div className="max-h-[216px] overflow-y-auto">
                <ul className="overflow-y-auto">
                  {getPersonalInfo(label).map((element) => (
                    <li
                      key={element.title}
                      onClick={() => {
                        field.field.onChange(
                          element.value === null ? null : element.value,
                        );
                        setShowContent(false);
                      }}
                    >
                      <p className="py-x px-1.5x cursor-pointer hover:bg-gray_light_1">
                        {isEnglish ? element.title : element.title_ar}
                      </p>
                    </li>
                  ))}
                </ul>
              </div>
            </SelectBoxInput>
          </div>
        );
      }}
    />
  );
};

export default Question;
